/**
 * Green Flag — MatchesChip
 *
 * Small pill shown on past-event cards summarizing mutual match counts.
 * Two tones: dating (green tint, heart icon) and friends (blue, smile).
 */

import { chakra, useRecipe } from "@chakra-ui/react";
import { Icon } from "../Icon/Icon";

export interface MatchesChipProps {
  count: number;
  tone: "dating" | "friends";
}

export function MatchesChip({ count, tone }: MatchesChipProps) {
  const recipe = useRecipe({ key: "badge" });
  const styles = recipe({
    visual: tone === "dating" ? "sparks" : "friendsChip",
  } as Parameters<typeof recipe>[0]);
  const icon = tone === "dating" ? "heart-filled" : "smile";
  const label = tone === "dating"
    ? `${count} ${count === 1 ? "Match" : "Matches"}`
    : `${count} ${count === 1 ? "Friend" : "Friends"}`;
  return (
    <chakra.span css={styles}>
      <Icon name={icon} boxSize="10px" />
      {label}
    </chakra.span>
  );
}
